// const API_BASE = 'http://localhost:8000';
const API_BASE = 'https://cdntest.riseapps.uk/api';

export const registerRequest = async (email, password) => {
  const response = await fetch(`${API_BASE}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Registration failed');
  }
  return await response.json();
};

export const verifyCode = async (email, code, ref) => {
  let url = `${API_BASE}/auth/verify?email=${encodeURIComponent(email)}&code=${encodeURIComponent(code)}`;
  if (ref) {
    url += `&ref=${encodeURIComponent(ref)}`;
  }
  const response = await fetch(url, {
    method: 'POST'
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Verification failed');
  }
  return await response.json();
};

export const resendCode = async (email) => {
  const response = await fetch(`${API_BASE}/auth/resend-code?email=${encodeURIComponent(email)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Ошибка при повторной отправке');
  }
  return response.json();
};

export const loginRequest = async (email, password) => {
  const formData = new URLSearchParams();
  formData.append('username', email);
  formData.append('password', password);
  const response = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: formData
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Login failed');
  }
  return await response.json();
};

// --- Данные пользователя ---
export const getUserInfo = async (token) => {
  const response = await fetch(`${API_BASE}/user/me`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to get user info');
  }
  return response.json();
};

export const getKeys = async (token) => {
  const response = await fetch(`${API_BASE}/keys`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to fetch keys');
  }
  return response.json();
};

export const buyKey = async (token, days, is_white_list = false) => {
  const response = await fetch(`${API_BASE}/keys/buy`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ days, is_white_list })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Purchase failed');
  }
  return response.json();
};

export const linkTelegram = async (token, tg_id) => {
  const response = await fetch(`${API_BASE}/auth/link-telegram`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ tg_id })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Link failed');
  }
  return response.json();
};

export const forgotPassword = async (email) => {
  const response = await fetch(`${API_BASE}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось отправить код сброса');
  }
  return response.json();
};

export const resetPassword = async (email, code, newPassword) => {
  const response = await fetch(`${API_BASE}/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code, new_password: newPassword })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось сбросить пароль');
  }
  return response.json();
};

export const changePassword = async (token, oldPassword, newPassword) => {
  const response = await fetch(`${API_BASE}/auth/change-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ old_password: oldPassword, new_password: newPassword })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось сменить пароль');
  }
  return response.json();
};

// --- 2FA ---
export const verify2fa = async (userId, code) => {
  const response = await fetch(`${API_BASE}/auth/verify-2fa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, code })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Ошибка подтверждения 2FA');
  }
  return response.json();
};

export const enable2fa = async (token) => {
  const response = await fetch(`${API_BASE}/auth/enable-2fa`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    // тело пустое
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось запросить включение 2FA');
  }
  return response.json();
};

export const confirmEnable2fa = async (token, code) => {
  const response = await fetch(`${API_BASE}/auth/confirm-enable-2fa`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ code })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось подтвердить включение 2FA');
  }
  return response.json();
};

export const disable2fa = async (token, password) => {
  const response = await fetch(`${API_BASE}/auth/disable-2fa`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ password })
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Не удалось отключить 2FA');
  }
  return response.json();
};

export const createPayment = async (token, amount, days, method, site_uuid = null, gb) => {
  const payload = { amount, days, method, gb };
  if (site_uuid && site_uuid.length > 0) {
    payload.site_uuid = site_uuid;
  }

  const response = await fetch(`${API_BASE}/payment/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось создать платёж');
  }
  return response.json();
};

export const getReferralStats = async (token) => {
  const res = await fetch(`${API_BASE}/referral/stats`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to load referral stats');
  return res.json();
};


export const requestEmailChange = async (token, newEmail) => {
  const response = await fetch(`${API_BASE}/change-email/request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ new_email: newEmail })
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось запросить смену email');
  }
  return response.json();
};

export const confirmEmailChange = async (token, newEmail, code) => {
  const response = await fetch(`${API_BASE}/change-email/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ new_email: newEmail, code })
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось подтвердить смену email');
  }
  return response.json();
};

export const revokeKey = async (token, uuid) => {
  const response = await fetch(`${API_BASE}/keys/revoke`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ uuid })
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось перевыпустить подписку');
  }
  return response.json();
};

export const getSubscriptionDevices = async (token, uuid) => {
  const response = await fetch(`${API_BASE}/keys/${encodeURIComponent(uuid)}/devices`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось получить список устройств');
  }
  return response.json();
};

export const deleteSubscriptionDevice = async (token, uuid, hwid) => {
  const response = await fetch(`${API_BASE}/keys/devices/delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ uuid, hwid })
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Не удалось удалить устройство');
  }
  return response.json();
};


export const getIndicatorStatus = async () => {
  const response = await fetch(`${API_BASE}/indicator`);
  if (!response.ok) {
    throw new Error('Failed to fetch indicator status');
  }
  return response.json();
};